import React, { useContext, useState } from "react";
import { LanguageContext } from "../context/language/LanguageContext";
import "../styles/summary.css";
import "../styles/policyApproval.css";
import { parseTemplate } from "../Utilities/licenseService";
import appConst from "../Utilities/appConst.json";
import { getLanguageDirection } from "../Utilities/languageDirection";
import { Checkbox } from "./ui/checkbox";

export default function PolicyApproval(props) {
  const languageContext = useContext(LanguageContext);
  const [isChecked, setIsChecked] = useState(false);

  const currentLanguage = languageContext.language?.id || "he";
  const direction = getLanguageDirection(currentLanguage);
  const licenseData = props.licenseData;

  const handleOnChange = (checked) => {
    const nextValue = !!checked;
    props.setIsApproved(nextValue);
    setIsChecked(nextValue);
  };

  const fallbackPayload = {
    template: languageContext.getTranslation(
      appConst.POLICY_APPROVAL_DEFAULT_TEMPLATE
    ),
    placeholders: {
      terms: {
        label: languageContext.getTranslation(appConst.POLICY_APPROVAL_TERMS_LABEL),
        url: "https://www.lupa.co.il/license/",
      },
      privacy: {
        label: languageContext.getTranslation(
          appConst.POLICY_APPROVAL_PRIVACY_LABEL
        ),
        url: "https://www.lupa.co.il/privacy/",
      },
    },
  };

  const payload = licenseData?.payload;
  const hasRequiredPlaceholders = ["terms", "privacy"].every(
    (key) => payload?.placeholders?.[key]?.label && payload?.placeholders?.[key]?.url
  );
  const isPayloadLanguageMismatch =
    payload?.language && payload.language !== currentLanguage;
  const effectivePayload =
    payload?.template && hasRequiredPlaceholders && !isPayloadLanguageMismatch
      ? payload
      : fallbackPayload;

  const checkboxLabel = parseTemplate(
    effectivePayload.template,
    effectivePayload.placeholders
  );

  return (
    <div
      className="container_policy_approval summary_container"
      data-testid="summary-policy-approval"
    >
      <div className="content_policy_approval" dir={direction} style={{ gap: "8px" }}>
        <div
          className="text-h3 item_clickabuleWrapper flex items-center"
          dir={direction}
          data-testid="summary-policy-approval-text"
        >
          <span>{checkboxLabel}</span>
        </div>
        <Checkbox
          className="checkbox h-5 w-5 shrink-0 self-center border-brand [&_svg]:h-3 [&_svg]:w-3"
          aria-label="policy approval"
          checked={isChecked}
          onCheckedChange={handleOnChange}
          data-testid="policy-approval-checkbox"
        />
      </div>
    </div>
  );
}
